import { Text, useToast } from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";

import { RanaTable } from "@nens/ranalib";

import { CopyButton } from "../../../_internal";

export const FileAsUrlsPanels = ({ urls }: { urls: { url: string; label: string }[] }) => {
  const intl = useIntl();
  const toast = useToast();

  const copyUrl = (url: string) => {
    navigator.clipboard.writeText(url);

    toast({
      title: intl.formatMessage({
        id: "copied",
        defaultMessage: "Copied!",
      }),
      description: intl.formatMessage({
        id: "success.copied_url",
        defaultMessage: "Copied URL to clipboard.",
      }),
    });
  };

  if (!urls.length) {
    return (
      <RanaTable.Row.Accordion.Panel rowId="no-urls" key="no-urls" fontSize="sm">
        <FormattedMessage
          id="publication.file_as_url.no_urls_available"
          defaultMessage="No URLs available"
        />
      </RanaTable.Row.Accordion.Panel>
    );
  }
  return urls.map(({ url, label }) => (
    <RanaTable.Row.Accordion.Panel
      pr={4}
      h="fit"
      rowId={url + "-url"}
      key={url + "-url"}
      fontSize="sm"
    >
      <Text as="span" w="table_cell_xxs" display="inline-block">
        {label}:
      </Text>{" "}
      <Text
        overflow="hidden"
        textOverflow="ellipsis"
        color="brand.analytic"
        as="span"
        onClick={() => copyUrl(url)}
        cursor="pointer"
      >
        {url}
      </Text>
      <CopyButton
        copyText={url}
        title={intl.formatMessage({
          id: "publication.file_as_url.copy_url",
          defaultMessage: "Copy URL",
        })}
        toastMessage={intl.formatMessage({
          id: "success.copied_url",
          defaultMessage: "Copied URL to clipboard.",
        })}
        boxSize="small_button"
      />
    </RanaTable.Row.Accordion.Panel>
  ));
};
